/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubjectStepModel from 'cio/models/subject-step';

interface TrueFalseArgs {
  step: SubjectStepModel;
}

export default class TrueFalse extends Component<TrueFalseArgs> {
  get branchTaken() {
    return ['true', 'false'][this.args.step.branchIndex];
  }
}
